module.exports = __webpack_public_path__ + "files/bdd468b46f094a1c3b429d90fd8b2b22.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-76x76.png
// module id = 1245
// module chunks = 76